"use client"

import { Typography } from "@/shared/ui/atoms"
import { CustomButton } from "@/shared/ui/molecules"
import useHospitalUIStore from "@/widgets/hospital/model/store"
import { useTranslations } from "next-intl"
import { useEffect, useState } from "react"
import { getStickyHeaderHeight } from "@/shared/utils/getStickyHeaderHeight"
import { scrollToHospitalTabs } from "@/widgets/hospital/lib/scrollToHospitalTabs"

interface ReviewTreatmentCaseTabsProps {
  reviewCount: string
  treatmentCaseCount: string
}

type tabType = {
  label: string
  value: "review" | "treatmentCase" | "hospitalInfo"
  count: string
}

const HospitalContentTabs = ({ reviewCount, treatmentCaseCount }: ReviewTreatmentCaseTabsProps) => {
  const t = useTranslations()
  const stickyTop = getStickyHeaderHeight()
  const tabs: tabType[] = [
    {
      label: t("reviewTreatmentCaseTabs.review"),
      value: "review",
      count: reviewCount,
    },
    {
      label: t("reviewTreatmentCaseTabs.treatmentCase"),
      value: "treatmentCase",
      count: treatmentCaseCount,
    },
    {
      label: t("reviewTreatmentCaseTabs.hospitalInfo"),
      value: "hospitalInfo",
      count: "",
    }
  ]
  const { selectedTab, setSelectedTab } = useHospitalUIStore()

  const getSelectedTabClassName = (tab: tabType["value"]) => {
    return selectedTab === tab ? "border-b-2 border-gray-900 pb-[10px]" : "border-b border-gray-200 pb-[11px]"
  }

  const getSelectedTabTextClassName = (tab: tabType["value"]) => {
    return selectedTab === tab ? "text-gray-900" : "text-gray-400"
  }

  useEffect(() => {
    return () => {
      setSelectedTab("review")
    }
  }, [])

  return (
    <>
      <div id="hospital-tabs-anchor"/>
      <div
        id="hospital-tabs"
        className={`sticky z-[101] w-full flex items-center bg-white`}
        style={{ top: stickyTop }}
      >
        {tabs.map((tab, index) => (
          <CustomButton
            key={`${tab.value}-${index}`}
            className={`flex-1 pt-[6px] ${getSelectedTabClassName(tab.value)}`}
            onClick={() => {
              setSelectedTab(tab.value)
              requestAnimationFrame(() => scrollToHospitalTabs({ behavior: "smooth" }))
            }}
          >
            <Typography size={14} lineHeight="normal" className={`flex-1 font-semibold text-center ${getSelectedTabTextClassName(tab.value)}`}>
              {tab.label}
              <span className={`font-medium ml-1 ${getSelectedTabTextClassName(tab.value)}`}>{tab.count}</span>
            </Typography>
          </CustomButton>
        ))}
      </div>
    </>
  )
}

export default HospitalContentTabs

